(function ($, window, undefined) {

    function VideoPlayer(args) {

        this.defaults = {
            videoPlayer:  null,
            selectors: {
                widgetContainer: '.video-player',
                videoElem: '.player-embed',
                btnPlay: '.btn-play-video'
            },

        };

        this.options = $.extend(true, {}, this.defaults, args);

        this.$widgetContainer = $(this.options.selectors.widgetContainer);
        this.$videoElem = this.parent(this.options.selectors.videoElem);
        this.$btnPlay = this.parent(this.options.selectors.btnPlay);



        this.initPlayer();
        this.initVideoTextCover();
        this.bindEvents();
     }

    /**
     * Returns a jQuery element that is a child of the parent element
     * @param selector
     * @returns {*|HTMLElement}
     */
    VideoPlayer.prototype.parent = function (selector) {
        return $(selector, this.$widgetContainer);
    };

    VideoPlayer.prototype.initPlayer = function () {
        this.videoPlayer = new Plyr(this.$videoElem[0], {
            controls:[
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'captions',
                'settings',
                'pip',
                'airplay',
                'fullscreen'
            ]
        });
    };

    VideoPlayer.prototype.initVideoTextCover = function () {
        var self = this;

        if (!this.$widgetContainer.closest('.video-text').length) {
            return;
        }

        this.setupVideoTextCover();

        this.videoPlayer.on('ready', function () {
            self.setupVideoTextCover();
        });

        this.videoPlayer.on('exitfullscreen', function () {
            window.requestAnimationFrame(function () {
                self.updateVideoTextCover();
            });
        });

        this.videoPlayer.on('enterfullscreen', function () {
            self.resetVideoTextCover();
        });
    };

    VideoPlayer.prototype.setupVideoTextCover = function () {
        var self = this;

        this.$videoWrapper = this.parent('.plyr__video-wrapper');
        this.$videoIframe = this.parent('.plyr__video-embed iframe');

        if (!this.$videoWrapper.length || !this.$videoIframe.length) {
            return;
        }

        this.updateVideoTextCover();

        if (!this.videoTextCoverResizeBound) {
            if (window.ResizeObserver) {
                this.videoTextResizeObserver = new window.ResizeObserver(function () {
                    self.updateVideoTextCover();
                });
                this.videoTextResizeObserver.observe(this.$widgetContainer[0]);
            }

            $(window).on('resize.video-text-player', function () {
                self.updateVideoTextCover();
            });

            this.videoTextCoverResizeBound = true;
        }
    };

    VideoPlayer.prototype.updateVideoTextCover = function () {
        var wrapperWidth;
        var wrapperHeight;
        var iframeWidth;
        var iframeHeight;
        var videoAspectRatio = this.getVideoAspectRatio();
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;
        var isFullscreen = this.videoPlayer.fullscreen && this.videoPlayer.fullscreen.active;

        if (!this.$videoWrapper || !this.$videoWrapper.length || !this.$videoIframe || !this.$videoIframe.length) {
            return;
        }

        if (!isDesktop || isFullscreen) {
            this.resetVideoTextCover();
            return;
        }

        wrapperWidth = this.$widgetContainer.innerWidth();
        wrapperHeight = this.$widgetContainer.innerHeight();

        if (!wrapperWidth || !wrapperHeight) {
            return;
        }

        iframeWidth = wrapperWidth;
        iframeHeight = iframeWidth / videoAspectRatio;

        if (iframeHeight < wrapperHeight) {
            iframeHeight = wrapperHeight;
            iframeWidth = iframeHeight * videoAspectRatio;
        }

        this.$widgetContainer.addClass('video-player--cover');
        this.$videoIframe.css({
            width: Math.ceil(iframeWidth) + 'px',
            height: Math.ceil(iframeHeight) + 'px'
        });
    };

    VideoPlayer.prototype.getVideoAspectRatio = function () {
        var ratio = this.videoPlayer && this.videoPlayer.ratio;
        var ratioParts;
        var ratioWidth;
        var ratioHeight;

        if (typeof ratio === 'string') {
            ratioParts = ratio.split(':');
            ratioWidth = parseFloat(ratioParts[0]);
            ratioHeight = parseFloat(ratioParts[1]);

            if (ratioWidth > 0 && ratioHeight > 0) {
                return ratioWidth / ratioHeight;
            }
        }

        return 16 / 9;
    };

    VideoPlayer.prototype.resetVideoTextCover = function () {
        this.$widgetContainer.removeClass('video-player--cover');

        if (this.$videoIframe) {
            this.$videoIframe.css({
                width: '',
                height: ''
            });
        }
    };

    VideoPlayer.prototype.playVideo = function (selector) {
        this.$widgetContainer.addClass('video-playing');
        this.videoPlayer.play();
    };

    VideoPlayer.prototype.bindEvents = function () {
        var self = this;

        this.$btnPlay.click(function () {
            self.playVideo();
        });
    };

    window.SVHA = window.SVHA || {};
    window.SVHA.Widgets = window.SVHA.Widgets || {};
    window.SVHA.Widgets.VideoPlayer = VideoPlayer;

})(jQuery, window);



